// https://www.npmjs.com/package/query-string
const queryString = require('query-string');

import portCode from "./json/portCode.json"
const items = portCode
var $ = require("jquery");
//https://www.npmjs.com/package/xml2js
var parseString = require('xml2js').parseString;

//https://www.npmjs.com/package/rename-keys
var renameKeys = require('rename-keys');

const Moment = require('moment');

//https://github.com/rotaready/moment-range#node--npm
const MomentRange = require('moment-range');
const moment = MomentRange.extendMoment(Moment);

export const tpePortCode = (function() {

    var searchPortCode = function(keyword){

		  const res = items.filter(obj => Object.values(obj).some(val => val.includes(keyword)));
		  return res;
    }
    
    var searchPortCodeByList = function(keywords){
      var resList = [];
      try{
        
        keywords.forEach(element => {
          resList.push(searchPortCode(element));
        });
        return resList;
      }catch(err){
        console.log(err);
        return resList;
      }
    }
    // 回傳要指定給模組的物件
    return {
        searchPortCode: searchPortCode,
        searchPortCodeByList: searchPortCodeByList
    }
}())

export const  dateFormat = function(date){
  if(date == ""){
    return ""
  } 
  var result = 
  moment(date,"YYYYMMDDh:mm").format("MMDD").toString() + "\n" +
  moment(date,"YYYYMMDDh:mm").format("HH:mm").toString() 
  return result
}

//範例
export const exPort = {
  report : "HistoryPortShipList",
  arg : {
    selectPort: "KEL",
    visaNo: undefined,
    special01: "False",
    special02: "False",
    spArrvDtFrom: "2018/05/27 00:00",
    spArrvDtTo: "2018/05/28 00:00",
  }
}

export const reports = ["HistoryPortShipList","InPortShipList","OutPortShipList"];

export const tpeUrl = (function() {
  const weburl = "https://tpnet.twport.com.tw/IFAWeb/Reports/";
  const XMLurl = "/DownloadXMLReport?";

  var historyPortFormat = {
    VESSEL_CNAME: "船名",
    VESSEL_ENAME: "英文名",
    GROSS_TOA: "總噸",

    ACTPORT_DTH: "進港靠妥",
    BEFORE_PORT: "前一港",
    CALL_SIGN: "船舶呼號",
    HISTORY_ID: "序號",
    IMO_NO: "IMO",
    ISIGNAL_DT: "進出港時間",
    JETTY_DT: "通過堤口時間",
    LEAVEP_DTH: "出港離碼",
    LOA: "總長",
    NEXT_PORT: "次一港",
    PBG_NAME: "代理",
    PILOT_EXP_TM: "預定引水時間",
    PLT_ARRIVE_DT: "引水時間",
    PLT_LEAVE_DT: "領港下船時間",
    REGISTER_NO: "船隻掛號",
    SAIL_CODE: "航次",
    SP_STS: "進出港",
    STA_TYPE: "船種類",
    VESSEL_NATION: "國籍",
    VESSEL_NO: "船舶號數",
    VISA_NO: "簽證編號",
    WHARF_CODE: "泊地碼頭",
  }


  var InPortFormat = {
    GOAL_ARRIVAL : "目的", 
    WHARF_CODE : "港口",
    PBG_NAME : "代理公司",
    RESERVE_BERTH_TIME : "預計靠泊時間", 
    RESERVE_LEAVE_BERTH_TIME : "預計離泊時間", 
    STA_TYPE : "船類型", 
    VESSEL_CNAME : "船名",
    VESSEL_ENAME : "英文名稱",
    VISA_NO	: "簽證編號", 
    SPS : "SPS"	,
    EXPECT_DT: "預計進出港時間",
    ACT_PORT_DT:"實際進出港時間",
    BEFORE_PORT:"上/下一港",
    ETA_DT : "船長報到ETA",
    VHF_DT : "VHF報到時間",
    LENGTH : "長度",
    GROSS_TOA:"毛重"
  }

  var OutPortFromat = {
    GOAL_ARRIVAL : "目的", 
    WHARF_CODE : "港口",
    PBG_NAME : "代理公司",
    RESERVE_BERTH_TIME : "預計靠泊時間", 
    RESERVE_LEAVE_BERTH_TIME : "預計離泊時間", 
    STA_TYPE : "船類型", 
    VESSEL_CNAME : "船名",
    VESSEL_ENAME : "英文名稱",
    VISA_NO	: "簽證編號", 
    SPS : "SPS"	,
    EXPECT_DT: "預計進出港時間",
    LEAVE_PORT_DT:"實際進出港時間",
    NEXT_PORT:"上/下一港",
    LENGTH : "長度",
    GROSS_TOA:"毛重"
  }
 
  var getUrlFromPort = function(portArg){

    var tpeUrlArg 
    
    if(portArg.arg.visaNo != undefined){
      portArg.arg.spArrvDtFrom = undefined
      portArg.arg.spArrvDtTo = undefined
      portArg.arg.vesselCname = undefined
      portArg.arg.callSign = undefined
      portArg.arg.vesselEname = undefined
      portArg.arg.spVesselNo = undefined
      portArg.arg.registerNo = undefined
    }

    if(portArg.report == "InPortShipList"){
      tpeUrlArg = {
        selectPort: portArg.arg.selectPort,
        orderBy:"spVesselNo",
        orderAsc:"ASC",
        
        spExpectDtFrom: portArg.arg.spArrvDtFrom,
        spExpectDtTo: portArg.arg.spArrvDtTo,
  
        special01: portArg.arg.special01,
        special02: portArg.arg.special02,
  
        visaNo: portArg.arg.visaNo, //簽證編號
  
        vesselCname: portArg.arg.vesselCname, //中文名稱
        callSign: portArg.arg.callSign, //船舶呼號
        vesselEname: portArg.arg.vesselEname, //英文名稱
        spVesselNo: portArg.arg.spVesselNo, //船舶號數
        registerNo: portArg.arg.registerNo//船舶掛號
  
      }
     
    }else{
      tpeUrlArg = {
        selectPort: portArg.arg.selectPort,
        orderBy:"spVesselNo",
        orderAsc:"ASC",
        
        spArrvDtFrom: portArg.arg.spArrvDtFrom,
        spArrvDtTo: portArg.arg.spArrvDtTo,
  
        special01: portArg.arg.special01,
        special02: portArg.arg.special02,
  
        visaNo: portArg.arg.visaNo, //簽證編號
  
        vesselCname: portArg.arg.vesselCname, //中文名稱
        callSign: portArg.arg.callSign, //船舶呼號
        vesselEname: portArg.arg.vesselEname, //英文名稱
        spVesselNo: portArg.arg.spVesselNo, //船舶號數
        registerNo: portArg.arg.registerNo//船舶掛號
  
      }
    }

    
    
    

    var web_preUrl = weburl+portArg.report+XMLurl
    var url_arg = tpeUrlArg
    var url = web_preUrl + queryString.stringify(url_arg, {sort: false});
    //visaNo_verify
    return url;
      
  }
  
  var portFormatConfigs = {
    formats:
    [
      {
        name:"HISTORY_PORT",
        format:historyPortFormat
      },
      {
        name:"IN_PORT",
        format:InPortFormat
      },
      {
        name:"OUT_PORT",
        format:OutPortFromat
      },
    ]
  }

  var getJsonListFromUrl = function(url,preSetting,callback){
    console.log(url)
    var yql ="https://query.yahooapis.com/v1/public/yql"
    var timeStampInMs = window.performance && window.performance.now && window.performance.timing && window.performance.timing.navigationStart ? window.performance.now() + window.performance.timing.navigationStart : Date.now();
    var random = Math.floor((Math.random(timeStampInMs) * 1000) + 1);
    
    
    var getXMLURL = "getfile.php";


    var yqlURL = [
			yql,
      "?q=" + 
      encodeURIComponent("select * from xml where url='"+ url + "'")+
      
      '&format=xml&diagnostics=true', 
			"&t=" + random,
			"&format=xml&callback=?"
    ].join("");
    


    $.ajaxSetup({async:false, cache: false});	

    var result =
    {
      ships: undefined,
      time: undefined
    }
    var r
    var xmlData = undefined
    var timeStart = new Date().getTime()
    
    var setting = {
      url: getXMLURL,
      type: 'GET',
      cache: false,
      data:{
        'url':url
      },
      async: true,
      crossDomain: true,
      success: function(data){
      try{
        var timeDone = new Date().getTime()
        result.time = timeDone - timeStart
        //console.log(data)
        if(result.time > 16000){
          callback(result);
          r.abort()
        }
        else if(data!==null){
          parseString(data, function (err, parseResult) {

            console.log(parseResult)

            result.ships = mapShipsFormat(parseResult)
          });
          callback(result);
          
        }else{
          r.abort()
          r = $.get(setting)
        }
        
      }catch(error){
        console.log(error)
        }
      },
      error: function(err){
        console.log(err)
      }
    }
    preSetting();
    r = $.ajax(setting);	
  }


  const visaNoVerify = function(visaNO){
    if(visaNo.length!=13) return undefined
  }

  const mapShipsFormat = function(datas){
    var final = {
      "資料分類":undefined,
      "資料":[]
    }
    
    try{
      
      var dataName = Object.keys(datas)[0];
      final["資料分類"] = dataName
      portFormatConfigs.formats.forEach(function(config){
        if(config.name == dataName){
          if(datas[dataName]["SHIP"] && datas[dataName]["SHIP"].length > 0){
            datas[dataName]["SHIP"].forEach(function(data){
            
              var obj = renameKeys(data,function(key,val){
                return config.format[key]
              })
              
              Object.keys(obj).forEach(function(key) {
                obj[key] = obj[key][0]
              })
              
              final["資料"].push(obj)
            })
          }
        }
      })
    }catch(error){
      console.log(error)
    }
    return final
  }

   

  return {
    getUrlFromPort: getUrlFromPort,
    getJsonListFromUrl: getJsonListFromUrl,
    dateFormat: dateFormat
  }
}())




// WEBPACK FOOTER //
// ./src/lib/tpeSearch/tpeSearch.js